import { TransactionTypeStatus } from 'dashboard/models/transaction-type';
import Sticker from 'design-system/components/Sticker';
import { assertNever } from 'lib/utils/types';

interface TransactionTypeStatusStickerProps {
  status: TransactionTypeStatus;
}

const TransactionTypeStatusSticker = ({ status }: TransactionTypeStatusStickerProps) => {
  switch (status) {
    case TransactionTypeStatus.Active:
      return <Sticker variant='success'>Active</Sticker>;
    case TransactionTypeStatus.Inactive:
      return <Sticker variant='basic'>Inactive</Sticker>;
    default:
      assertNever(status);
  }
};

export default TransactionTypeStatusSticker;
